import get from 'lodash/get';

export const selectPrevLocation = state =>
  get(state, 'common.locations.previousLocation');
export const isUrlPreview = state => get(state, 'common.urlPreview');
export const currentLocationSelector = state =>
  get(state, 'common.locations.currentLocation');



// WEBPACK FOOTER //
// ./src/redux/common/selectors.js